import { render, staticRenderFns } from "./student_link.vue?vue&type=template&id=462957d2&scoped=true&"
import script from "./student_link.vue?vue&type=script&lang=js&"
export * from "./student_link.vue?vue&type=script&lang=js&"
import style0 from "./student_link.vue?vue&type=style&index=0&id=462957d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462957d2",
  null
  
)

export default component.exports